// extracted by mini-css-extract-plugin
export var expandIcon = "c8_m7";
export var rotated = "c8_m8";